module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12gkOEr/images/cover.jpg?1738810491178",
      "alt": "This image is the cover for the book Quilted Celebrations"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quilted Celebrations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A quilt for the special events in your life Don’t let the important occasions in life pass you by. Quilt them! Gift meaningful milestone quilts for religious celebrations, graduations, anniversaries, important birthdays, and more. Best-selling author and fabric designer Amanda Murphy presents 10 projects and 18 designs to celebrate life’s hallmark moments. Space is cleverly built into the designs so you can personalize them with numbers, dates, messages, and signatures. Amanda’s patterns are simple to stitch and easy to mix and match. Incorporate embroidery, appliqué, elaborate quilting designs, or large-scale fabric prints with this ultimate resource for quilted gifts. • Celebrate life’s important moments, from birthdays and anniversaries to bar mitzvahs • 10 projects and 18 designs, easy to mix and match • Personalize it! Add names, numbers, dates, messages, and signatures • From best-selling author, Bernina spokesperson, and fabric designer Amanda Murphy")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Murphy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Murphy is a quilt and fabric designer whose style bridges the modern and traditional. She is a BERNINA Expert and Quilting and Longarm Spokesperson, popular teacher, fabric designer for Contempo of Benartex, and pattern designer under her own label. amandamurphydesign.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0